import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import authReducer from "./authReducer";
import danhMucReducer from "./danhMucReducer";
import khoReducer from "./khoReducer";
import banHangReducer from "./BanHang/BanHangReducer";
import danhMucNhomSanPhamReducer from "./DanhMuc/DanhMucNhomSanPhamReducer";
import danhMucAttributesReducer from "./DanhMuc/DanhMucAttributesReducer";
import danhMucGiaCongReducer from "./DanhMuc/DanhMucGiaCongReducer";
import danhMucKhachHangReducer from "./DanhMuc/DanhMucKhachHangReducer";
import hethongReducer from "./HeThongNT/HeThongNTReducer";
import chiNhanhReducer from "./DanhMuc/ChiNhanhReducer";
import groupCate_CusRatePriceReducer from "./DanhMuc/GroupCate_CusRatePriceReducer";
import userReducer from "./User/UserReducer";

import { reducer as formReducer } from "redux-form";

//Danh sách đơn Đặt hàng
import dataSearchDanhSachDonDatHangReducer from "./DanhSachDonDatHang/dataSearchDanhSachDonDatHangReducer";
import listDanhSachDonDatHangReducer from "./DanhSachDonDatHang/listDanhSachDonDatHangReducer";
import listInNhanhDanhSachDonDatHangReducer from "./DanhSachDonDatHang/listInNhanhDanhSachDonDatHangReducer";

//Danh sách đơn hàng
import dataSearchDanhSachDonHangReducer from "./DanhSachDonHang/dataSearchDanhSachDonHangReducer";
import listDanhSachDonHangReducer from "./DanhSachDonHang/listDanhSachDonHangReducer";

//Danh sách chi nhánh
import dataSearchDanhSachChiNhanhReducer from "./HeThong/DanhSachChiNhanh/dataSearchDanhSachChiNhanhReducer";
import listDanhSachChiNhanhReducer from "./HeThong/DanhSachChiNhanh/listDanhSachChiNhanhReducer";

const appReducer = combineReducers({
  routing: routerReducer,
  auth: authReducer,
  danhmuc: danhMucReducer,
  kho: khoReducer,
  danhMucNhomSanPham: danhMucNhomSanPhamReducer,
  danhMucAttributes: danhMucAttributesReducer,
  danhMucGiaCong: danhMucGiaCongReducer,
  danhMucKhachHang: danhMucKhachHangReducer,
  banhang: banHangReducer,
  hethongNT: hethongReducer,
  chinhanh: chiNhanhReducer,
  user: userReducer,
  groupCate_CusRatePrice: groupCate_CusRatePriceReducer,
  //Danh sách đơn đặt hàng
  dataSearchDanhSachDonDatHang: dataSearchDanhSachDonDatHangReducer,
  listDanhSachDonDatHang: listDanhSachDonDatHangReducer,
  inNhanhDanhSachDonDatHang: listInNhanhDanhSachDonDatHangReducer,
  //Danh sách đơn hàng
  dataSearchDanhSachDonHang: dataSearchDanhSachDonHangReducer,
  listDanhSachDonHang: listDanhSachDonHangReducer,
  // Danh sách chi nhanh
  listDanhSachChiNhanh: listDanhSachChiNhanhReducer,
  dataSearchDanhSachChiNhanh: dataSearchDanhSachChiNhanhReducer,

  form: formReducer,
});

const rootReducer = (state, action) => {
  // console.log("RESET_ALL_DATA action", action)
  if (action.type === "RESET_ALL_DATA") {
    state = {
      auth: state.auth,
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
